import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Locize from 'i18next-locize-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(Locize)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en-GB',
        saveMissing: true,
        debug: process.env.REACT_APP_ENVIRONMENT === 'development',
        interpolation: {
            escapeValue: false
        },
        backend: {
            projectId: process.env.REACT_APP_LOCIZE_PROJECT,
            apiKey: process.env.REACT_APP_ENVIRONMENT === 'development' ? process.env.REACT_APP_LOCIZE_API_KEY : ''
        }
    })
    .then(() => {
        i18n.services.formatter.add('lowercase', (value) => {
            return value.toLowerCase();
        });
    });

export default i18n;
